module.exports = __webpack_public_path__ + "img/top_text.66f31d07.png";